export * from "./curry"
export * from "./others"
/**
 * 根据一个联合string类型K, 创建一个Record<K,{}>, 参数里keys的每个值都将对应一个{}
 */
export function createEmptyRecord<K extends string>(keys: ReadonlyArray<K>): Record<K, any> {
  const result = {} as Record<K, any>
  keys.forEach(k => (result[k] = {}))
  return result
}

/**
 * 在一个Record里找到指定key, 找到则返回对应的值, 找不到则创建一个{},并将其赋值给Record对应的key,并返回
 */
export function getOrInitEmpty<K extends string | number, V extends Object>(r: Record<K, V>, key: K): V {
  let result = r[key]
  if (result === undefined) {
    result = {} as V
    r[key] = result
  }
  return result
}

export function getOrInitEmptyArray<K extends string | number, V>(r: Record<K, V[]>, key: K): V[] {
  let result = r[key]
  if (result === undefined) {
    result = []
    r[key] = result
  }
  return result
}

//@ts-ignore
export function checkHasKey<T extends object>(t: T, s: string): s is keyof T {
  return s in t
}

export function list2dict<T, K extends keyof T>(
  list: ReadonlyArray<T>,
  key: K & (T[K] extends string | number | symbol ? K : never),
): Record<T[K] & (string | number | symbol), T> {
  return list.reduce(
    (acc, item) => {
      acc[item[key] as T[K] & (string | number | symbol)] = item
      return acc
    },
    {} as Record<T[K] & (string | number | symbol), T>,
  )
}

export function limitValue(v: number, min: number, max: number) {
  return Math.min(Math.max(v, min), max)
}

export function removeUndefine<T>(t: T | undefined): t is T {
  return t !== undefined
}

export function intRange(start:number,count:number){
    const result:number[] =[];
    for(let i=0;i<count;i++) result.push(start+i);
    return result;
}
